// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__2fOqw","container":"LayoutSideNavigation_container__33yjn","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__39Um0"};